import {PlaceId} from '@jetbrains/teamcity-ui/dist/plugin'

import Plugin from '../Plugin/Plugin'
import PluginWrapper from '../Plugin/PluginWrapper/PluginWrapper'

import useAiAssistantChatWrapper from './useAiAssistantChatWrapper'

import styles from './AiAssistantChatWrapper.module.css'

interface AiAssistantChatWrapperProps {
  isClassicUi?: boolean
}

function AiAssistantChatWrapper({isClassicUi = false}: AiAssistantChatWrapperProps) {
  useAiAssistantChatWrapper()

  if (isClassicUi) {
    return null
  }

  return (
    <PluginWrapper placeId={PlaceId.SAKURA_AI_ASSISTANT_CHAT}>
      <Plugin placeId={PlaceId.SAKURA_AI_ASSISTANT_CHAT} className={styles.pluginContainer} />
    </PluginWrapper>
  )
}

export default AiAssistantChatWrapper
